module.exports = __webpack_public_path__ + "static/img/blog_banner.8ff1ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_banner.png
// module id = ufel
// module chunks = 8